import { useQuery } from '@tanstack/react-query'
import { request } from '../../api/client'
import type { AdminStats } from './types'

/** §5, one request. Every figure the API returns is already the honest one — nothing here recomputes anything from a partial list. */
export function useAdminStats() {
  return useQuery({
    queryKey: ['admin', 'stats'],
    queryFn: () => request<AdminStats>('/api/admin/stats'),
  })
}
